if (!customElements.get('seo-text-block')) {
  customElements.define(
    'seo-text-block',
    class SeoTextBlock extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          seoText: '.seo-content__text',
          seoToggleBtn: '.seo-content__toggle',
          seoToggleBtnText: '.seo-content__toggle--text',
          seoToggleIconDown: '.seo-content__toggle--caret-down',
        };

        this.classes = {};

        this.seoText = this.querySelector(this.selectors.seoText);
        this.originalSeoText = this.seoText ? this.seoText.cloneNode(true) : '';
        this.seoToggleBtn = this.querySelector(this.selectors.seoToggleBtn);
        this.seoToggleBtnText = this.seoToggleBtn
          ? this.seoToggleBtn.querySelector(this.selectors.seoToggleBtnText)
          : null;
        this.seoToggleBtnIconDown = this.seoToggleBtn
          ? this.seoToggleBtn.querySelector(this.selectors.seoToggleIconDown)
          : null;

        this.truncateAfter = 1000; // Number of characters to show before truncating

        this.init();
      }

      disconnectedCallback() {
        if (this.seoToggleBtn) {
          this.seoToggleBtn.removeEventListener(
            'click',
            this.toggleSeoText.bind(this)
          );
        }
      }

      init() {
        if (!this.seoText || !this.seoToggleBtn) return;

        this.truncateSeoText();

        this.seoToggleBtn.addEventListener(
          'click',
          this.toggleSeoText.bind(this)
        );
      }

      truncateSeoText() {
        // Reset to current text before truncating
        this.seoText = this.querySelector(this.selectors.seoText);

        if (this.seoText.textContent.length > this.truncateAfter) {
          this.seoText.classList.add('truncated');
          this.seoText.innerHTML =
            this.seoText.innerHTML.slice(0, this.truncateAfter) +
            '<span>...</span>';
        } else {
          this.seoToggleBtn.style.display = 'none';
        }
      }

      showFullSeoText() {
        this.seoText.classList.remove('truncated');

        // Replace the truncated text with copy of the original text node to preserve formatting
        this.seoText.replaceWith(this.originalSeoText.cloneNode(true));
      }

      toggleSeoText() {
        const isTruncated = this.seoText.classList.contains('truncated');

        if (isTruncated) {
          this.showFullSeoText();

          this.seoToggleBtn.classList.add('toggle-expanded');
          this.seoToggleBtnIconDown.style.transform = 'rotate(180deg)';
        } else {
          this.truncateSeoText();

          this.seoToggleBtn.classList.remove('toggle-expanded');
          this.seoToggleBtnIconDown.style.transform = 'rotate(0deg)';
        }
      }
    }
  );
}